import React from 'react';
import { useAuth } from '../../utils/context/AuthContext';
const DeleteAccount = () => {
  const { deleteAccount } = useAuth();
  // Delete account function, need to give password to delete account
  const handleDelete = async () => {
    // Delete account logic here
    if (window.confirm('Are you sure you want to delete your account?')) {
      const password = window.prompt('Please enter your password to delete your account');

      if (password) {
        await deleteAccount({ password });
      }
    }
  };

  return (
    <div>
      <button onClick={handleDelete} className="btn btn-danger mt-3">
        Delete Account
      </button>
    </div>
  );
};

export default DeleteAccount;
